'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _CompanyIsTff = require('./CompanyIsTff.css');

var _CompanyIsTff2 = _interopRequireDefault(_CompanyIsTff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyIsTff = (_dec = (0, _reactCssModules2.default)(_CompanyIsTff2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyIsTff, _Component);

  function CompanyIsTff(props) {
    (0, _classCallCheck3.default)(this, CompanyIsTff);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyIsTff.__proto__ || (0, _getPrototypeOf2.default)(CompanyIsTff)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(CompanyIsTff, [{
    key: 'render',
    value: function render() {
      var iconTo = require('../../../static/images/icons/tff-icon.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'family-modal' },
        _react2.default.createElement(
          'div',
          { styleName: 'icon-row' },
          this.props.company.is_to ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconTo, title: 'Tobacco producer' }) : null,
          this.props.company.is_tm ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconTo, title: 'Tobacco-promoting entertainment' }) : null
        )
      );
    }
  }]);
  return CompanyIsTff;
}(_react.Component), _class2.propTypes = {
  company: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = CompanyIsTff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyIsPanels/CompanyIsTff.js
// module id = 1384
// module chunks = 0